import React from 'react';
import useTranslation from '../../../../../../../hooks/translation/useTranslation';
import { bankTypesToCountry } from '../../../../../../../../utils/constants';
import CustomerRadioInput from '../../../../../../inputs/customerRadioInput/CustomerRadioInput';

function CountryBankOptions() {
  const { configInfo } = useTranslation();

  const currentCountryBankTypes = bankTypesToCountry?.[configInfo?.countryCode];

  return currentCountryBankTypes?.length && (
    <CustomerRadioInput
      name="payment_bank"
      groupClassName="flex flex-col gap-5"
      options={currentCountryBankTypes?.map(
        (type) => ({
          label: type?.name,
          value: type?.name,
          visible: true,
        }),
      )}
    />
  );
}

export default CountryBankOptions;
